const NotFound = () => (
  <div className="w-full flex flex-row justify-center items-center m-3 p-3 bg-slate-100 shadow-md">
    <p className="text-xl">
      <span className="text-8xl text-red-500">Error 404!</span> Page not found
    </p>
  </div>
);

export default NotFound;
